// extracted by mini-css-extract-plugin
module.exports = {"container":"Selector_container__1w6Qe","iconWrapper":"Selector_iconWrapper__UqUi0","icon":"Selector_icon__2CRBG","name":"Selector_name__20WWf","active":"Selector_active__lAGCh"};